var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 1.66669V7.00002M11.9999 7.00002C6.10888 7.00002 1.33325 11.7756 1.33325 17.6667C1.33325 23.5577 6.10888 28.3334 11.9999 28.3334C17.891 28.3334 22.6666 23.5577 22.6666 17.6667C22.6666 11.7756 17.891 7.00002 11.9999 7.00002ZM9.33325 1.66669H14.6666M21.8215 6.09572L23.2357 7.50994M15.5172 13.8002L11.746 17.5714M15.5355 13.7979L11.7642 17.5691",
    stroke: "#4C60E5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer_icon.61b7f87d4fb66964892fb19796fcf148.svg";
export { ForwardRef as ReactComponent };